import { LicenceDocument } from "../licence/LicenceDocument";
import { DocumentPayload } from "../skills/documentpayload";

export class UserLicence {
  public licenceId: number = 0;
  public licenceMasterId: number = 0;
  public userLicenceId:number = 0;
  public userLicenceName: string = '';
  public userLicenceNumber: string = '';
  public licenceCountry: string = '';
  public licenceAuthority: string = '';
  public licenceOn: string = '';
  public effectiveDate;
  public expiryDate;
  public documents: LicenceDocument[] = [];
}
